import React, { ReactNode } from 'react';

interface SafeAreaViewProps {
  children: ReactNode;
}

/**
 * Passthrough.
 *
 * Antes este componente envolvia toda la app en `IonPage > IonContent`, lo que
 * invierte la estructura de Ionic: `IonApp` debe ser la raiz, no un hijo de un
 * `IonContent`. Con el SDK de iOS 26 esa inversion rompe la app: el scroll
 * container del IonContent queda por encima del header, que pierde su fondo y
 * deja de recibir los toques (botones muertos).
 *
 * Ademas el padding que aplicaba nunca sirvio para el header: el `IonPage` de
 * cada pagina es `position: absolute`, asi que lo escapa.
 *
 * El safe area superior se resuelve donde corresponde, en el propio header
 * (ver `ToolBar.scss`), que es lo que Ionic espera.
 */
export const SafeAreaView: React.FC<SafeAreaViewProps> = ({ children }) => <>{children}</>;
